export const connect = {
  body: [
    'Ha érdekel a testalkatok világa is, érdemes összekötnöd a színtanácsadással, és a teljes tanácsadás csomagomat választanod!',
    'Így nem csak kedvezményes csomagáron veheted igénybe mindkét szolgáltatást, hanem minden eszközt megkapsz ahhoz, hogy ezentúl sokkal könnyebb legyen az eligazodás a ruhásszekrényedben vagy a ruhaboltokban.'
  ]
}
